var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"main-box"},[_c('h1',[_vm._v("页面建设中...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }